var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSunlightSome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    enableBackground: "new 0 0 36 36",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M18,5.5c0.46,0,0.834-0.373,0.834-0.833V1.333C18.834,0.873,18.46,0.5,18,0.5s-0.833,0.373-0.833,0.833 v3.333C17.167,5.127,17.54,5.5,18,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M28.025,9.17l2.35-2.367c0.324-0.327,0.322-0.854-0.004-1.178c-0.327-0.325-0.855-0.323-1.18,0.004 l-2.35,2.367c-0.324,0.327-0.322,0.854,0.004,1.179C27.173,9.499,27.7,9.497,28.025,9.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M9.777,22.03c0.546-0.056,1.142-0.109,1.808-0.159C10.901,20.74,10.5,19.418,10.5,18 c0-4.142,3.358-7.5,7.5-7.5c4.143,0,7.5,3.358,7.5,7.5c0,1.427-0.405,2.755-1.097,3.891c0.595,0.041,1.2,0.089,1.818,0.143 c0.599-1.219,0.944-2.584,0.944-4.033c0-5.063-4.104-9.167-9.166-9.167S8.833,12.938,8.833,18 C8.833,19.448,9.179,20.813,9.777,22.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M34.666,17.167h-3.332c-0.461,0-0.834,0.374-0.834,0.833s0.373,0.834,0.834,0.834h3.332 c0.461,0,0.834-0.374,0.834-0.834S35.127,17.167,34.666,17.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M7.976,9.17C8.3,9.497,8.827,9.499,9.154,9.175s0.329-0.852,0.004-1.179l-2.35-2.367 C6.484,5.303,5.956,5.301,5.629,5.625C5.303,5.95,5.301,6.477,5.625,6.804L7.976,9.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M5.5,18c0-0.46-0.373-0.833-0.833-0.833H1.333C0.873,17.167,0.5,17.54,0.5,18s0.373,0.834,0.833,0.834 h3.333C5.127,18.834,5.5,18.46,5.5,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSunlightSome);
export default __webpack_public_path__ + "static/media/icon-sunlight-some.b4d04b102fe82eedeed7d8fb22e418cf.svg";
export { ForwardRef as ReactComponent };